import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Users, MessageSquare, Calendar } from "lucide-react";

const Community: React.FC = () => {
  const location = useLocation();
  const canonicalUrl = `https://buildwithchrist.ai${location.pathname}`;

  return (
    <div className="min-h-screen py-12 px-4 max-w-7xl mx-auto">
      <Helmet>
        <title>Community | Build With Christ</title>
        <meta name="description" content="Connect with fellow builders, nonprofits, and mission-driven technologists in the BuildWithChrist community." />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4 font-display">Join Our Community</h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          Connect with fellow builders, nonprofits, and mission-driven technologists
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-card border border-border p-8 rounded-xl text-center">
          <div className="p-4 bg-primary/10 text-primary rounded-full w-fit mx-auto mb-4">
            <Users size={48} />
          </div>
          <h3 className="font-bold text-xl mb-2">Discord Community</h3>
          <p className="text-muted-foreground mb-4">Join our Discord server to chat with other builders</p>
        </div>
        <div className="bg-card border border-border p-8 rounded-xl text-center">
          <div className="p-4 bg-secondary/10 text-secondary rounded-full w-fit mx-auto mb-4">
            <MessageSquare size={48} />
          </div>
          <h3 className="font-bold text-xl mb-2">Discussion Forum</h3>
          <p className="text-muted-foreground mb-4">Share ideas and get feedback on your projects</p>
        </div>
        <div className="bg-card border border-border p-8 rounded-xl text-center">
          <div className="p-4 bg-primary/10 text-primary rounded-full w-fit mx-auto mb-4">
            <Calendar size={48} />
          </div>
          <h3 className="font-bold text-xl mb-2">Upcoming Events</h3>
          <p className="text-muted-foreground mb-4">Stay updated on future build events and workshops</p>
        </div>
      </div>
    </div>
  );
};

export default Community;
